import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { ChevronDown } from '@gravity-ui/icons';
import { Button, Card as CardBase, Icon, Popover, Text } from '@gravity-ui/uikit';
import isString from 'lodash/isString';
import { COMMON_POPOVER_PLACEMENT, COMMON_TITLE_MAX_WIDTH } from '../../constants/common';
import { block } from '../../utils';
import './Card.css';
const b = block('card');
export const Card = ({ name, title: propsTitle, description, actions, open: propsOpen, onToggle, alwaysOpen, disableHeaderToggle, checkEmptyBody, children, }) => {
    var _a;
    const containerRef = React.useRef(null);
    const titleRef = React.useRef(null);
    const bodyRef = React.useRef(null);
    const [open, setOpen] = React.useState(alwaysOpen || propsOpen || false);
    const emptyBody = Boolean(bodyRef.current && !bodyRef.current.childElementCount);
    const handleToggle = React.useMemo(() => {
        if (!alwaysOpen) {
            return () => {
                setOpen(!open);
                onToggle === null || onToggle === void 0 ? void 0 : onToggle(!open);
            };
        }
        return;
    }, [alwaysOpen, open, setOpen, onToggle]);
    const handleHeaderToggle = React.useMemo(() => {
        if (!disableHeaderToggle && handleToggle) {
            return handleToggle;
        }
        return;
    }, [disableHeaderToggle, handleToggle]);
    const preventEvent = React.useCallback((e) => e.stopPropagation(), []);
    const titlePopoverDisabled = (((_a = titleRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0) <= COMMON_TITLE_MAX_WIDTH;
    const title = React.useMemo(() => {
        if (isString(propsTitle)) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Popover, { content: propsTitle, disabled: titlePopoverDisabled, placement: COMMON_POPOVER_PLACEMENT },
                    React.createElement(Text, { className: b('title'), ellipsis: true, ref: titleRef, variant: "subheader-2" }, propsTitle)),
                description ? (React.createElement("div", { className: b('note') },
                    React.createElement(HelpPopover, { htmlContent: description, placement: COMMON_POPOVER_PLACEMENT }))) : null));
        }
        return propsTitle;
    }, [propsTitle, titlePopoverDisabled, description]);
    React.useEffect(() => {
        if (!alwaysOpen && propsOpen !== undefined && propsOpen !== open) {
            setOpen(propsOpen);
        }
    }, [propsOpen]);
    React.useEffect(() => {
        if (checkEmptyBody &&
            bodyRef.current &&
            !bodyRef.current.childElementCount &&
            containerRef.current &&
            !containerRef.current.className.includes('df-card_empty-body')) {
            containerRef.current.classList.add('df-card_empty-body');
        }
    });
    return (React.createElement(CardBase, { ref: containerRef, className: b({ 'empty-body': emptyBody }), type: "container", theme: "normal" },
        React.createElement("div", { className: b('header', { interactive: Boolean(handleHeaderToggle) }), onClick: handleHeaderToggle },
            React.createElement("div", { className: b('header-left') }, title),
            React.createElement("div", { className: b('header-right'), onClick: preventEvent },
                actions ? React.createElement("div", { className: b('actions') }, actions) : null,
                alwaysOpen ? null : (React.createElement("div", { className: b('toggler') },
                    React.createElement(Button, { view: "flat", onClick: handleToggle, qa: `${name}-accordeon-toggler` },
                        React.createElement(Icon, { className: b('toggler-icon', { open }), data: ChevronDown, size: 16 })))))),
        React.createElement("div", { ref: bodyRef, className: b('body', { open }) }, children)));
};
